/* Waïloa PERF2 (2 oct.) – Flickity à la demande (accueil et collections).
   Ces pages n'ont plus de carrousel Flickity : la bibliothèque (68 Ko, plusieurs secondes de calcul) n'est plus chargée d'office.
   Filet de sécurité : si une section ajoutée plus tard appelle $(...).flickity(...), le fichier est chargé à ce moment-là
   et les appels en attente sont rejoués dans l'ordre. */
(function () {
  var $ = window.jQuery, me = document.currentScript;
  if (!$ || !$.fn || $.fn.flickity || window.Flickity) return;
  var src = me && me.getAttribute('data-src'), queue = [], loading = false;
  function load() {
    if (loading || !src) return; loading = true;
    var s = document.createElement('script');
    s.src = src;
    s.onload = function () {
      var real = $.fn.flickity;
      if (!real || real === stub) return;
      var q = queue; queue = [];
      q.forEach(function (c) { real.apply(c[0], c[1]); });
    };
    document.head.appendChild(s);
  }
  function stub() {
    if (!this.length) return this;
    queue.push([this, arguments]); load();
    return this;
  }
  $.fn.flickity = stub;
})();
